import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import {
	InputBase,
	FormControl,
	Select,
	Input,
	MenuItem,
	Checkbox,
	ListItemText,
} from '@material-ui/core';

import http from '@common/http';

import { useTranslation } from '@common/utils';

import { useSettings } from '@common/hooks';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

function SeasonPicker({ dates, setDates, boxes }) {
	const classes = useStyles();
	const tr = useTranslation();
	const [seasons, setSeasons] = useState([]);
	const [selectedSeasons, setSelectedSeasons] = useState([]);
	const { headerLinkText } = useSettings();


	const handleChange = (event) => {
		setDates({
			...dates,
			seasons: event.target.value.filter(Boolean).join(','),
		});
	};

	useEffect(() => {
		(async () => {
			const { data } = await http.get('/api/kiosks/student-housing/seasons?active=true');

			setSeasons(data.sort((a, b) => {
				return ((a.nr || Infinity) - (b.nr || Infinity)) || a.from.localeCompare(b.from);
			}).map(s => ({
				value: s._id,
				label: s.title,
			})));
		})().catch(console.error);
	}, []);

	useEffect(() => {
		if (!seasons || !dates?.seasons) { return; }
		const selectedSeasons = seasons.filter(s => dates.seasons.includes(s.value)).map(s => s.label);
		setSelectedSeasons(selectedSeasons);
	}, [seasons, dates]);

	return (<div className={`${classes.container} ${boxes ? classes.boxes : classes.pickers}`}>
		{!boxes
			? <FormControl className={classes.formControl} style={{ width: headerLinkText ? 300 : 490 }}>
				<Select
					labelId="demo-mutiple-checkbox-label"
					id="demo-mutiple-checkbox"
					displayEmpty
					multiple
					value={dates.seasons.split(',').filter(Boolean)}
					onChange={handleChange}
					input={<Input />}
					renderValue={(selected) => {
						if (selected.length === 0) {
							return <em>{tr('Select season')}</em>;
						}

						return selected.map(s => seasons.find(season => season.value === s)?.label).join(', ');
					}}
					MenuProps={MenuProps}
				>
					<MenuItem disabled value="">
						<em>{tr('Select season')}</em>
					</MenuItem>
					{seasons.map((season) => (
						<MenuItem key={season.value} value={season.value}>
							<Checkbox color="primary" checked={dates.seasons.split(',').filter(Boolean).includes(season.value)} />
							<ListItemText primary={season.label} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
			: <label className={classes.box}>
				<div className={classes.label}>{tr('Season')}</div>
				<InputBase className={classes.date} value={selectedSeasons.join(', ')} placeholder={boxes ? '-' : `${tr('Season')}`} readOnly />
			</label>
		}
	</div>);
}

SeasonPicker.propTypes = {
	dates: PropTypes.object.isRequired,
	setDates: PropTypes.func.isRequired,
	boxes: PropTypes.bool,
};

export default SeasonPicker;

const useStyles = makeStyles(theme => ({
	container: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
	},
	pickers: {
		padding: '3px 8px',
		border: `1px solid ${theme.palette.custom.borders}`,
		borderRadius: '4px',

		[theme.breakpoints.down('sm')]: {
			padding: '2px 0',
			marginBottom: theme.spacing(2),
		},
	},
	input: {
		border: 0,
		width: '128px',
		padding: '4px 0',
		fontFamily: 'inherit',
		color: theme.palette.primary.dark,
		'& input': {
			textAlign: 'center',
			fontSize: '16px',
		},
		[theme.breakpoints.down('sm')]: {
			width: '110px',
		},
	},
	separator: {
		width: '14px',
		height: '1px',
		backgroundColor: theme.palette.custom.separator,

		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	label: {
		fontWeight: 600,
	},
	box: {
		textAlign: 'center',
		padding: '1px 16px',
		border: `1px solid ${theme.palette.custom.borders}`,
		borderRadius: '4px',
		lineHeight: '1.4rem',
		marginLeft: '8px',
		cursor: 'pointer',

		[theme.breakpoints.up('sm')]: {
			padding: '1px 32px',
		},
		[theme.breakpoints.up('md')]: {
			padding: '1px 48px',
		},

		'&:hover': {
			borderColor: theme.palette.custom.main,
		},
	},
	date: {
		color: theme.palette.primary.dark,
		minWidth: '70px',
		height: '22px',
		'& input': {
			textAlign: 'center',
			fontSize: '16px',
			cursor: 'pointer',
		},
	},
	formControl: {
		margin: theme.spacing(1),
	},
}));
